import { Outlet } from "react-router-dom";
import { AdminChrome } from "@/components/admin/AdminChrome";

export function CrmLayout() {
  return (
    <div className="relative min-h-dvh overflow-x-hidden bg-gradient-to-br from-amber-50 via-white to-rose-50 text-foreground">
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute inset-0 bg-[radial-gradient(70%_50%_at_15%_-10%,rgba(251,113,133,0.10),transparent_60%)]" />
        <div className="absolute inset-0 bg-[radial-gradient(60%_45%_at_100%_100%,rgba(251,191,36,0.10),transparent_55%)]" />
      </div>

      <AdminChrome />

      <main className="relative z-10">
        <Outlet />
      </main>
    </div>
  );
}
